import { render, staticRenderFns } from "./BackgroundItem.vue?vue&type=template&id=0fdd0250&scoped=true"
import script from "./BackgroundItem.vue?vue&type=script&lang=js"
export * from "./BackgroundItem.vue?vue&type=script&lang=js"
import style0 from "./BackgroundItem.vue?vue&type=style&index=0&id=0fdd0250&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd0250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd0250')) {
      api.createRecord('0fdd0250', component.options)
    } else {
      api.reload('0fdd0250', component.options)
    }
    module.hot.accept("./BackgroundItem.vue?vue&type=template&id=0fdd0250&scoped=true", function () {
      api.rerender('0fdd0250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/background/BackgroundItem.vue"
export default component.exports